
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'الرئيسية', path: '/' },
    { name: 'من نحن', path: '/about' },
    { name: 'المنتجات', path: '/products' },
    { name: 'العلامات التجارية', path: '/brands' },
    { name: 'تواصل معنا', path: '/contact' },
  ];

  const services = [
    'أنظمة كاميرات المراقبة',
    'أنظمة التحكم في الدخول',
    'البوابات الأمنية',
    'أنظمة الإنذار',
    'الشبكات والبنية التحتية',
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', url: '#', label: 'فيسبوك' },
    { icon: 'ri-twitter-x-fill', url: '#', label: 'تويتر' },
    { icon: 'ri-linkedin-fill', url: '#', label: 'لينكد إن' },
    { icon: 'ri-instagram-line', url: '#', label: 'انستغرام' },
    { icon: 'ri-youtube-fill', url: '#', label: 'يوتيوب' },
  ];

  return (
    <footer className="bg-gray-50 border-t border-silver-light text-navy-light">
      <div className="container mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1 - Logo & Description */}
          <div>
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/3054ead814191935f25c9e6dd446a98c.png"
              alt="شركة الحلول الأمنية المتكاملة"
              className="h-16 w-auto mb-6"
            />
            <p className="text-gray-dark text-[15px] leading-relaxed mb-6">
              شريكك الموثوق في توفير حلول الأنظمة الأمنية المتكاملة والمشاريع الكبرى بأعلى معايير الجودة والاحترافية.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-silver text-gray-dark hover:bg-primary hover:border-primary hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-navy">روابط سريعة</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-dark text-[15px] hover:text-primary hover:translate-x-1 inline-block transition-all duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-navy">خدماتنا</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to="/products"
                    className="text-gray-dark text-[15px] hover:text-primary hover:translate-x-1 inline-block transition-all duration-300"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-navy">تواصل معنا</h3>
            <ul className="space-y-5">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-phone-line text-primary text-lg"></i>
                </div>
                <a href="tel:+966500000000" className="text-gray-dark text-[15px] hover:text-primary transition-all duration-300">
                  +966 50 000 0000
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-mail-line text-primary text-lg"></i>
                </div>
                <a href="mailto:info@security-solutions.com" className="text-gray-dark text-[15px] hover:text-primary transition-all duration-300">
                  info@security-solutions.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-primary text-lg"></i>
                </div>
                <p className="text-gray-dark text-[15px] leading-relaxed">
                  الرياض، المملكة العربية السعودية
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-silver-light bg-white">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-medium text-sm">
              © {currentYear} جميع الحقوق محفوظة - شركة الحلول الأمنية المتكاملة
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-gray-medium text-sm hover:text-primary transition-all duration-300">
                سياسة الخصوصية
              </Link>
              <span className="text-silver">|</span>
              <Link to="/terms" className="text-gray-medium text-sm hover:text-primary transition-all duration-300">
                الشروط والأحكام
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
